import angular from 'angular';

import { compilerService } from './CompilerService';

/**
 * @ngdoc    overview
 * @name     csm.ng
 * @description
 * System utilities. For use in declaration, initialization, and customization of
 * AngularJS applications.
 **/
export default angular
  .module('csm.ng', [])
  .service('CompilerService', compilerService)
  .name;
